import { render, staticRenderFns } from "./company-identifier.html?vue&type=template&id=a3372642&scoped=true&"
import script from "./company-identifier.js?vue&type=script&lang=js&"
export * from "./company-identifier.js?vue&type=script&lang=js&"
import style0 from "./company-identifier.scss?vue&type=style&index=0&id=a3372642&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3372642",
  null
  
)

export default component.exports